export default __webpack_public_path__ + "static/media/Path3437.68839ad0.svg";